'use strict';

angular.module('licensure.services')
    .factory('Documents', ['$http', '$q', 'Upload', function ($http, $q, Upload) {
        return {
            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Documents/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (document, saveAll, value) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/Documents/';
                if (!isUndefined(document.id)) {
                    method = 'PUT'
                    url += document.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        document: document,
                        saveAll: saveAll,
                        value: value
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/Documents/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            upload: function (document, value) {
                var d = $q.defer();

                Upload.upload({
                    url: apiLocation + '/api/Documents/upload',
                    data: {
                        file: document.file, 
                        name: document.name,
                        description: document.description,
                        document_type_id: document.document_type_id == null ? undefined : document.document_type_id,
                        candidate_id: document.candidateID,
                        expiration_date: document.expiration_date,
                        object_id: value,
                        fromComplaint: document.fromComplaint == null ? undefined : document.fromComplaint,
                        data_object_id: document.data_object_id == null ? undefined : document.data_object_id,
                    }
                }).then(function (resp) {
                    d.resolve(resp.data);
                }, function (resp) {
                    console.log('Error status: ', resp);
                    d.resolve(null);
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                });

                return d.promise;
            },

            logAccess: function (id) {
                var d = $q.defer();

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/Documents/LogDocumentAccess',
                    data: {
                        document_id: id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            downloadZip: function (documentIds) {
                var d = $q.defer();

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/Core/Zip',
                    data: JSON.stringify({
                        documentIds: documentIds.toString()
                    }),
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },

            getByUserForQuestionID: function (parameters) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Core/DocumentsByUser/' + parameters.user_id + '/' + parameters.question_id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getDocumentsByInspection: function (inspection_id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Core/DocumentsByInspection/' + inspection_id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(null);
                    });

                return d.promise;
            },

            createDocumentObject: function (documentID, value, data_object) {
                var d = $q.defer();

                $http.post(apiLocation + "/api/Documents/createDocumentObject", {
                    documentID: documentID,
                    value: value,
                    data_object: data_object
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },
        }
    }])
;